import React, { Component } from 'react'

export default class Assets extends Component {
    render() {
        return (
            <div>
                <h5>Assets</h5>
            </div>
        )
    }
}
